import React from 'react';
import PropTypes from 'prop-types';

import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

import IconServeceo from 'components/icons/iconServeceo';
import DesktopOnly from 'components/consumer/DesktopOnly';
import CheckoutSubmitButton from '../../../CheckoutSubmitButton';
import CheckoutProtectionPlanItem from './CheckoutProtectionPlanItem';

const CheckoutProtectionPlans = ({
  cart,
  goToTab,
  avoCheckoutStepCompleted,
  getCartIssues,
  calculateTotal,
  client,
}) => {
  const postHogFlag = usePostHogFeatureFlag('protectionPlanCheckoutCopy');
  const buttonTitleText =
    postHogFlag === 'test'
      ? 'Continue Without Protection Plan'
      : 'Continue to Billing';

  let eligiblePlans = [];
  if (cart && cart.length) {
    cart.forEach(item => {
      if (
        item.eligible_protection_plans &&
        eligiblePlans.length < item.eligible_protection_plans.length
      ) {
        eligiblePlans = item.eligible_protection_plans;
      }
    });
  }

  return (
    <div>
      {cart &&
        cart.length > 0 &&
        cart.map(cartItem => (
          <CheckoutProtectionPlanItem
            getCartIssues={getCartIssues}
            calculateTotal={calculateTotal}
            client={client}
            cartItem={cartItem}
          />
        ))}

      <div className="text-xs font-bold mb-8 [&_a:active]:text-brand [&_a:hover]:text-brand [&_a:link]:[&:link]:text-brand [&_a:visited]:text-brand">
        See the{' '}
        <a href="/furniture-protection-plan/" target="_blank">
          full terms
        </a>{' '}
        for our protection plans.
      </div>
      <div className="lg:flex lg:-mt-4 lg:items-center lg:justify-between">
        <DesktopOnly>
          <div className="max-[1023px]:hidden text-xs font-bold text-gray [&_span]:pr-4 [&_svg]:relative [&_svg]:top-1">
            <span>In partnership with</span>
            <IconServeceo />
          </div>
        </DesktopOnly>

        <div className="flex justify-end my-[30px]">
          <CheckoutSubmitButton
            dataXc="delivery-button"
            onClick={() => {
              avoCheckoutStepCompleted({ step: 4 });
              goToTab('payment');
            }}
            id="continue-to-billing"
          >
            {buttonTitleText}
          </CheckoutSubmitButton>
        </div>
      </div>
    </div>
  );
};

CheckoutProtectionPlans.propTypes = {
  calculateTotal: PropTypes.func,
  cart: PropTypes.array,
  client: PropTypes.object,
  getCartIssues: PropTypes.func,
  goToTab: PropTypes.func,
  avoCheckoutStepCompleted: PropTypes.func,
};

export default CheckoutProtectionPlans;
